import styled from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

export const StyledTooltipButton = styled.button`
  display: block;
  padding: 0;
  margin: 0;
  border: none;
  box-shadow: none;
  background: transparent;
  cursor: pointer;
  color: ${colorsPalettes.blue[300]};
`;

export const StyledTooltipLink = styled.a`
  display: block;
  color: ${colorsPalettes.blue[300]};
  text-decoration: none;

  &:hover {
    color: ${colorsPalettes.blue[300]};
  }
`;
